import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Send } from "lucide-react";

export function Conversation({ msgs, userId, text, setText, onSend }) {
  return (
    <div className="md:col-span-2 bg-white border border-border rounded-sm flex flex-col">
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {msgs.map((m) => (
          <div key={m.id} className={`flex ${m.sender_id === userId ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[70%] px-3 py-2 rounded-sm text-sm ${m.sender_id === userId ? "bg-primary text-white" : "bg-slate-100"}`}>{m.text}</div>
          </div>
        ))}
        {msgs.length === 0 && <div className="text-center text-muted-foreground text-sm mt-8">Say hello 👋</div>}
      </div>
      <div className="p-3 border-t border-border flex gap-2">
        <Input data-testid="message-input" value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && onSend()} placeholder="Type a message…" />
        <Button data-testid="message-send" onClick={onSend}><Send className="w-4 h-4" /></Button>
      </div>
    </div>
  );
}
